module.exports = __webpack_public_path__ + "img/brought.aee59979.svg";